import React from "react";

export default function Roadmap() {
  const gridrow = (Q, title, li1, li2, li3, li4, li5, li6, li7, li8) => (
    <div className="grid w-full grid-cols-roadmap">
      <h1 className="text-lg text-right">{Q}</h1>
      <div className="flex flex-col items-center">
        <Circle />
        <span className="h-full w-[2px] bg-gray-400"></span>
      </div>
      <div>
        <h1 className="text-xl font-bold text-sky-800 dark:text-sky-500">
          {title}
        </h1>
        <ul className="ml-4 list-disc mt-4 text-gray-500 dark:text-gray-400">
          <li>{li1}</li>
          <li>{li2}</li>
          <li>{li3}</li>
          <li>{li4}</li>
          <li>{li5}</li>
          <li>{li6}</li>
          <li>{li7}</li>
          <li>{li8}</li>
        </ul>
        <div className="h-12"></div>
      </div>
    </div>
  );

  return (
    <div id="roadmap" className="w-full flex flex-col pb-10 items-center text-sky-800 dark:text-white">
      <div className="grid gap-12 md:grid-cols-discover w-10/12 md:w-9/12">
        <div>
          <p className="text-sm border-b pb-2 font-medium border-sky-800 dark:border-gray-100 mt-4 uppercase">
            ROADMAP
          </p>
        </div>
        <div>
          <h1 className="text-4xl font-bold mt-3">
            Our Strategy &{" "}
            <span className="dark:text-sky-500">Plans</span>
          </h1>
          <div className="w-full mt-10">
            {gridrow(
              "Q4 2022",
              "Launch & Assemble",
              "Finalizing lead formalities",
              "Completing internal and external formatlities",
              "Organizing core team members",
              "Launch event",
              "Community building",
              "Social Media marketing",
              "Partnering with DataCamp",
              "Partnering with Metaschool"
            )}
            {gridrow(
              "Q1 2023",
              "Hands on knowledge",
              "Cloud Jam",
              "Complete Bootcamp 1",
              "Design Workshops",
              "Finalizing core team members based on performance",
              "Partnering with NFT Studio 24",
              "Getting students ready to participate in solution challenge",
              "Provide help in brainstorming ideas",
              "Farewell and swag distribution for last lead and core team"
            )}
            {gridrow(
              "Q2 2023",
              "Bridging gap between industries and academia",
              "Industry visits",
              "Android seekho",
              "Cloud seekho",
              "Hackathons and workshops",
              "Startup collaboration for better interships and job opportunites",
              "Mock interviews",
              "Increasing DataCamp account limit",
              "Complete Bootcamp2"
            )}
            {gridrow(
              "Q3 2023",
              "Tenure end and Farewell",
              "Job and intership opportunites",
              "Complete bootcamp3",
              "Resources provide for future reference",
              "Top volunteers finalized",
              "Career counseling",
              "New lead finalizing",
              "Swags and price distribution",
              "Testimonial listing of top performers"
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function Circle() {
  return (
    <div className="p-1 rounded-full border-2 flex items-center justify-center border-gray-400">
      <div className="h-2 w-2 rounded-full bg-gray-400"></div>
    </div>
  );
}
